import { PlayerDto } from '../Dtos/PlayerDto';
import TurnDto from '../Dtos/TurnDto';
export class SynchronizeGameValuesRequest {
    static Message = 'SynchronizeGameValuesRequest';
}

export class SynchronizeGameValuesResponse {
    static Message = 'SynchronizeGameValuesResponse';

    public currentTurn: TurnDto | null;
    public players: PlayerDto[];
    public selectedPlaylist: string | null;
    public cardsToWin: number;

    constructor(currentTurn: TurnDto | null, players: PlayerDto[], selectedPlaylist: string | null, cardsToWin: number = 10) {
        this.currentTurn = currentTurn;
        this.players = players;
        this.selectedPlaylist = selectedPlaylist;
        this.cardsToWin = cardsToWin;
    }
}
